
<!-- Header Structure -->
<template>
  <div>
   <header>
      <div class="navbar-blue">
        <div class="container pr-0 pl-0 px-lg-0 px-xl-2">
          <b-navbar toggleable="lg" type="dark">
              <b-navbar-toggle target="nav-collapse" class="px-0"></b-navbar-toggle>
              <b-navbar-brand class="mr-lg-4 mt-0 " href="/"><img class="icon" alt="Aeru_logo" src="../../assets/top/PC_mobile/images/logo.png"></b-navbar-brand>

              <b-collapse id="nav-collapse" is-nav class="ml-auto" v-if="this.is_url == '/'">
                <b-navbar-nav class="ml-auto pr-4">
                  <b-nav-item href="/seeker/resume" class="px-2">履歴書編集</b-nav-item>
                  <b-nav-item href="/jobs" class="px-2">求人を探す</b-nav-item>
                  <b-nav-item href="/job_how_to_use" class="px-2">{{$t("message.how_to_use")}}</b-nav-item>
                  <b-nav-item href="/mypage" class="px-2">{{$t("message.to_go_exam")}}</b-nav-item>
                </b-navbar-nav>
              </b-collapse>

              <b-collapse id="nav-collapse" is-nav  v-else class="text-center">
                <b-navbar-nav class="ml-auto">
                  <b-nav-item href="/seeker/resume" class="px-2">履歴書編集</b-nav-item>
                  <b-nav-item href="/jobs" class="px-2">求人を探す</b-nav-item>
                  <b-nav-item href="/job_how_to_use" class="px-2">{{$t("message.how_to_use")}}</b-nav-item>
                  <b-nav-item href="/mypage" class="px-2">{{$t("message.to_go_exam")}}</b-nav-item>
                </b-navbar-nav>
              </b-collapse>


              <ul class="navbar-nav ml-auto">
                <b-form-select v-model="language" @change="setLanguage" :options="options" class="selectNav languageSelect"></b-form-select>
                <li class="nav-item active">
                  <signin-modal v-if="this.outh == null"  ref="login" @showSignup="showSignup"></signin-modal>
                  <b-nav-item-dropdown
                    id="my-nav-dropdown"
                    class='setting-down selectNav py-0 pr-0 myNav  header-dropdown-menu'
                    right
                    no-caret
                    v-else
                  >
                    <template v-slot:button-content class="py-0">

                      <span class="b-avatar bg-white rounded-circle" style="width: 2.5em; height: 2.5em;">
                        <span class="b-avatar-text" style="font-size: calc(1em);">
                          <span><b>{{name}}</b></span>
                        </span>
                      </span>
                    </template>
                    <b-dropdown-item class='text-black' :href='"/" + item.value' v-for='item in optionsLogin' :key='item.value'>{{ item.text }}</b-dropdown-item>
                    <b-dropdown-item class='text-black' @click="signout()">{{ logout.text }}</b-dropdown-item>
                  </b-nav-item-dropdown>
                </li>
              </ul>

          </b-navbar>
        </div>
        <signup-modal ref="signup" @showLogin="showLogin"></signup-modal>

      </div>
    </header>

    <b-modal v-model="isFirstVisit"  hide-footer>
      <div class="row">
        <div class="col-12 pl-4 text-center">
          <h4>{{ $t("message.plece_select_language") }}</h4>
          <div class="active firstSelectWrap ml-2 mt-3 text-center">
            <b-form-select v-model="language" :options="options" class="selectNav languageSelect topSelect firstSelect"></b-form-select>
          </div>
        </div>
      </div>

      <div class="w-100 mt-4">
        <b-button  class="start py-2 px-4 width100" @click="setLanguage" > {{$t("message.select")}} </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import cognito from "@/cognito";
import {Auth} from 'aws-amplify';
import axios from 'axios';
import SigninModal from "@/components/User/Session/SigninModal";
import SignupModal from "@/components/User/Session/SignupModal";
export default {
    components: {
        SigninModal,
        SignupModal
      },
    data() {
        return {
            is_url: this.$route.path,
            isFirstVisit: localStorage.isFirstVisit,
            lineModal: false,
            noLoading: ['/', '/createuser', '/createUser','/payment','/learning_consul','/termservice','/specificcommerce','/privacypolicy','/account_setting','/email_setting', '/past-exam'],
            options: [
              { value: 'ja', text: 'Japanese' },
              { value: 'en', text: 'English(Philippines)' },
              { value: 'bn', text: 'Bangladesh'},
              { value: 'bur', text: 'Burmese(Myanmar)' },
              { value: 'hi', text: 'Indhi' },
              { value: 'id', text: 'Indonesian' },
              { value: 'kh', text: 'Khmer(Cambodia)' },
              { value: 'lo', text: 'Lao' },
              { value: 'mn', text: 'Mongolian' },
              { value: 'ne', text: 'Nepali' },
              { value: 'th', text: 'Thai' },
              { value: 'vi', text: 'Vietnamese' },
              { value: 'lk', text: 'Sinhalese' }
            ],
            language: "",
            selected: null,
            name: null,
            user_d: {},
            logout: { value: 'logout', text: this.$i18n.t('message.logout')},
            optionsLogin: [
              { value: 'mypage', text: this.$i18n.t('message.mypage') },
              { value: 'account_setting', text: this.$i18n.t('message.account_setting') },
              { value: 'profile_setting', text: this.$i18n.t('message.profile_setting') },
              { value: 'visa_application', text: this.$i18n.t('message.visa_application') },
            ]
        };
    },
    methods: {
        checkMode() {
          if(this.is_url == '/' || this.is_url == '/termservice' || this.is_url == '/privacypolicy' || this.is_url == '/specificcommerce' || this.is_url == '/payment' || this.is_url == '/createUser') {
            return false
          } else if(this.name != '') {
            return true
          }
        },
        setName() {
          if (this.memberInfo.first_name == null) {
            this.name = this.user.attributes.email.toUpperCase()[0]
          } else {
            if(this.ja2Bit(this.memberInfo.first_name) ){
              this.name = this.memberInfo.first_name[0]
            }else{
              this.name = this.memberInfo.first_name.toUpperCase()[0]
              this.name += this.memberInfo.last_name.toUpperCase()[0]
            }
          }
        },
        /* 言語を返納した際にフロント上で言語をセットする */
        setLocalLanguage(l) {
          this.$i18n.locale = this.LANGUAGE_LIST[l]
          this.locale = this.LANGUAGE_LIST[l]
          this.language = this.LANGUAGE_LIST[l]
          this.$store.commit('setLanguage', this.LANGUAGE_LIST[l])
        },
        isAuthenticated() {
          return Auth.isAuthenticated()
        },
        showSignup(){
          this.$refs.signup.showModal()
        },
        showLogin(){
           this.$refs.login.showModal()
        },
        setLangText(val) {
           this.$i18n.locale = val
           this.$store.commit('setLanguage', val)
           this.locale = val
           this.optionsLogin = [
             { value: 'mypage', text: this.$i18n.t('message.mypage') },
             { value: 'account_setting', text: this.$i18n.t('message.account_setting') },
             { value: 'profile_setting', text: this.$i18n.t('message.profile_setting') },
             { value: 'visa_application', text: this.$i18n.t('message.visa_application') },
           ]
           this.logout = { value: 'logout', text: this.$i18n.t('message.logout')}
        },
        /* 言語を返納した際にユーザーのメイン言語を変更した言語に更新する */
        setLanguage() {
          var regist = {user:{sub: this.user_d.sub, language: this.R_LANGUAGE_LIST[this.language]}}
          localStorage.isFirstVisit = false
          this.isFirstVisit = false
          axios
            .patch(process.env.VUE_APP_API + "/users/" + this.user_d.id, regist, {headers: {'Authorization': 'Bearer ' + localStorage.idToken}})
            .then(response => {
              this.$store.commit('user/setUser', response.data)
            }).catch(error => {
              console.log('this is error', error)
            })
        },
        signout(){
          localStorage.idToken = ''
          this.$store.commit('user/setUserOuth', null);
          Auth.signOut().then(() =>{
            this.$swal.fire({
              icon: 'success',
              title: this.$i18n.t('message.do_logout')
            }).then(()=>{
              this.$router.push('/')
            })

          })
          .catch(error => {
            console.log(error)
          })
        },
        ja2Bit( str ) {
          return ( str.match(/^[\u30a0-\u30ff\u3040-\u309f\u3005-\u3006\u30e0-\u9fcf]+$/) )? true : false
        }
    },
    watch:{
        selected(val, old){
          if (val != old) {
            this.$router.push({ path: './' })
          }
        },
        language(val){
          this.setLangText(val)
        },
        lang(val) {
          this.setLangText(val)
        },
        '$route': function (to, from) {
          this.is_url = to.path
          if (to.path !== from.path) {
            this.$i18n.locale = this.LANGUAGE_LIST[this.memberInfo.language]
            this.locale = this.LANGUAGE_LIST[this.memberInfo.language]
            this.language = this.LANGUAGE_LIST[this.memberInfo.language]

            this.setName()
          }
        },
        async memberInfo(val){
          this.occupation = val.current_industry
          //await this.getAnyinfo()
        }
    },
    async mounted(){
        if(this.isFirstVisit == undefined){
          this.isFirstVisit = true
        }
        if(this.$i18n.locale == 'enUS'){
          this.language = "en"
          this.$store.commit('setLanguage', this.language)
        } else if(this.$i18n.locale == 'vi'){
          this.language = "vi"
          this.$store.commit('setLanguage', this.language)
        } else {
          this.language = this.$i18n.locale
          this.$store.commit('setLanguage', this.language)
        }

        if(this.$route.path != '/createuser'){
            await Auth.currentAuthenticatedUser()
              .then((data) => {
                const token = data.signInUserSession.accessToken.jwtToken
                localStorage.idToken = token
                this.$store.commit('user/setUserOuth', data);

                axios
                .get(process.env.VUE_APP_API + "/users/callback", {headers: {'Authorization': 'Bearer ' + token}})
                  .then(response => {
                    this.user_d = response.data
                    this.$store.commit('user/setUser', response.data)
                    this.$store.commit('user/setMemberInfo', response.data)

                    if(response.data.language != null){
                      this.setLocalLanguage(response.data.language)
                    }else{
                      this.$i18n.locale = navigator.language.split('-')[0]
                      this.$store.commit('setLanguage', navigator.language.split('-')[0])
                    }
                    this.setName()
                }).catch(error => {
                  console.log('this is error', error)
                })
              })
              .catch(session => {
                session = null
                this.$store.commit('user/setUserPool', session)
                var l = navigator.language.toLowerCase().split('-')[0]
                this.$i18n.locale = l
                this.language= l
                this.$store.commit('setLanguage', l)
              })
        } else {
          this.setName()
          if(this.memberInfo.language != null){
            this.setLocalLanguage(this.memberInfo.language)
          }
        }
        if( this.noLoading.indexOf(this.$route.path) !== -1){
          this.$store.commit('setLoading', false)
        }
    },
    computed: {
        ...mapState({
          user: state => state.user.outh,
          memberInfo: state => state.user.user,
          lang: state => state.language,
          outh: state => state.user.outh,
          isFirstVisit: state => state.isFirstVisit
        }),
    },
};
</script>
<style scoped lang="scss">
.btn{
    padding: .235rem .75rem;
}
@media (max-width: 768px) {
   .navbar-nav {
        -webkit-box-orient: horizontal !important;
        display: -webkit-box;
   }
}
.icon{
  height: 35px !important;
}

.setting-down ::v-deep .dropdown-toggle::after {
  content: '' ;
    width: 15px ;
    height: 15px ;
    border: 0px ;
    border-bottom: solid 3px #FFFFFF ;
    border-right: solid 3px #FFFFFF ;
    -ms-transform: rotate(45deg) ;
    -webkit-transform: rotate(45deg) ;
    transform: rotate(45deg) ;
    position: absolute ;
    top: 33% ;
    right: 1em ;
    margin-top: -4px ;
}

.b-avatar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    font-size: inherit;
    font-weight: 400;
    line-height: 1;
    max-width: 100%;
    max-height: auto;
    text-align: center;
    overflow: visible;
    position: relative;
    top: -8px;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,box-shadow .15s ease-in-out;
}

.b-avatar-text {
    border-radius: inherit;
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
}

.b-avatar .b-avatar-text {
    text-transform: uppercase;
    white-space: nowrap;
    color: #000054;
}
.languageSelect {
  max-width: 80%;
  padding: 0px !important;
}
.header-dropdown-menu ul {
  position: absolute !important;
}
.select-occupation {
  background-color: white !important;
}
.topSelect {
  color: black;
  max-width: 100%;
  z-index: unset !important;
}

.firstSelect{
  font-size: 1.5rem;
}

.start{
  background: #F29147 !important;
  color: #FFFFFF !important;
  font-size: 16px;
  border-color: #F29147!important;
}
.sp {
  display: none
}
.chase-btn {padding: 0 0 15% 0

}

.chase-btn img {
  width:45px;
    transition: all .3s ease 0s;
}

.chase-btn img:hover {
  cursor: pointer;
	transform: scale(1.2);
}



.chase-btn2 {

}

.chase-btn2 img {
  width: 45px;
    transition: all .3s ease 0s;
}

.chase-btn2 img:hover {
  cursor: pointer;
	transform: scale(1.2);
}
@media only screen and (max-width: 767px) {
.sp {
  display: block;
}
}

.sns-box{right: 500px;top:14px}
.sns{width: 35px}
.sns-boxs{display:inline-block}

.pc {
  display: none
}
.sp {
  display: none 
}

@media only screen and (max-width: 480px) {
  .pc {
    display: none
  }
  .sp {
    display: block
  }
}

</style>
